module.exports = __webpack_public_path__ + "static/media/ellipse-left.d18f8554.svg";